import { render, staticRenderFns } from "./UpdateRoomLog.vue?vue&type=template&id=53854248&lang=pug&"
import script from "./UpdateRoomLog.vue?vue&type=script&lang=ts&"
export * from "./UpdateRoomLog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports